import { ArtificialIntelligenceIcon } from 'foundations-assets/icons/components/ArtificialIntelligenceIcon';
import { CommunicationIcon } from 'foundations-assets/icons/components/CommunicationIcon';
import { ConditionalIcon } from 'foundations-assets/icons/components/ConditionalIcon';
import { CrmIcon } from 'foundations-assets/icons/components/CrmIcon';
import { IntegrationsIcon } from 'foundations-assets/icons/components/IntegrationsIcon';
import { MarketingIcon } from 'foundations-assets/icons/components/MarketingIcon';
import { ProductBundleIcon } from 'foundations-assets/icons/components/ProductBundleIcon';
import { TasksIcon } from 'foundations-assets/icons/components/TasksIcon';
export const MAX_VISIBLE_ICONS = 3;
export const ICON_HOLDER_SIZE = '100';
export const ICON_HOLDER_OUTER_SIZE = '27px';
export const ICON_URL_IMAGE_SIZE = '20px';
export const ICON_URL_IMAGE_MARGIN_BLOCK_START = '25';
// Combined category mapping from ActionCategoryThemes (automation-ui-action-features)
// and CATEGORY_ICON_MAP / CATEGORY_COLOR_MAP from
// automation-studio-intro-ui-lib/components/create-workflow/TemplateIconsList.tsx
export const CATEGORY_ICON_MAP = {
  AI_SKILLS: {
    icon: ArtificialIntelligenceIcon,
    iconColor: 'fill-accent-magenta-default',
    backgroundColor: 'fill-accent-magenta-subtle-alt'
  },
  COMMUNICATIONS: {
    icon: CommunicationIcon,
    iconColor: 'fill-accent-purple-default',
    backgroundColor: 'fill-accent-purple-subtle-alt'
  },
  CRM: {
    icon: CrmIcon,
    iconColor: 'fill-accent-green-default',
    backgroundColor: 'fill-accent-green-subtle-alt'
  },
  DATA_OPS: {
    icon: ProductBundleIcon,
    iconColor: 'fill-accent-yellow-default',
    backgroundColor: 'fill-accent-yellow-subtle-alt'
  },
  MARKETING: {
    icon: MarketingIcon,
    iconColor: 'fill-accent-light-orange-default',
    backgroundColor: 'fill-accent-light-orange-subtle-alt'
  },
  QUICK_ACTIONS: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  WORK: {
    icon: TasksIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  UNCATEGORIZED: {
    icon: IntegrationsIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  }
};
export const ACTION_TYPE_ICON_MAP = Object.assign({}, CATEGORY_ICON_MAP, {
  // COMMUNICATIONS
  CLASSIC_NOTIFICATION_EMAIL: CATEGORY_ICON_MAP.COMMUNICATIONS,
  EMAIL: CATEGORY_ICON_MAP.COMMUNICATIONS,
  EMAIL_NOTIFICATION: CATEGORY_ICON_MAP.COMMUNICATIONS,
  IN_APP_NOTIFICATION: CATEGORY_ICON_MAP.COMMUNICATIONS,
  SEND_SMS_NOTIFICATION: CATEGORY_ICON_MAP.COMMUNICATIONS,
  SLACK_NOTIFICATION: CATEGORY_ICON_MAP.COMMUNICATIONS,
  // CRM
  CLASSIC_COPY_COMPANY_PROPERTY: CATEGORY_ICON_MAP.CRM,
  CREATE_OBJECT: CATEGORY_ICON_MAP.CRM,
  CREATE_SALESFORCE_CAMPAIGN: CATEGORY_ICON_MAP.CRM,
  CREATE_SALESFORCE_TASK: CATEGORY_ICON_MAP.CRM,
  INCREASE_PROPERTY: CATEGORY_ICON_MAP.CRM,
  ROTATE_OBJECT: CATEGORY_ICON_MAP.CRM,
  SET_PROPERTY: CATEGORY_ICON_MAP.CRM,
  TASK: CATEGORY_ICON_MAP.CRM,
  // DATA_OPS
  CUSTOM_CODE: CATEGORY_ICON_MAP.DATA_OPS,
  EXTENSION: CATEGORY_ICON_MAP.DATA_OPS,
  FORMULA: CATEGORY_ICON_MAP.DATA_OPS,
  WEBHOOK: CATEGORY_ICON_MAP.DATA_OPS,
  // MARKETING
  ADS_AUDIENCE_MEMBERSHIP: CATEGORY_ICON_MAP.MARKETING,
  ALTER_LIST_MEMBERSHIP: CATEGORY_ICON_MAP.MARKETING,
  CLASSIC_ALTER_LIST_MEMBERSHIP: CATEGORY_ICON_MAP.MARKETING,
  SET_MARKETING_STATUS: CATEGORY_ICON_MAP.MARKETING,
  UPDATE_EMAIL_SUBSCRIPTION: CATEGORY_ICON_MAP.MARKETING,
  // QUICK_ACTIONS
  AB_TEST_BRANCH: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  ALL_BRANCHES: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  ALL_DELAYS: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  CLASSIC_ANCHORED_DELAY: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  CLASSIC_ENROLL_IN_WORKFLOW: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  CLASSIC_VIRTUAL_ANCHORED_DELAY: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  CRITERIA_BRANCH: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  DELAY: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  DELAY_UNTIL_DATE: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  ENROLL_IN_FLOW: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  GO_TO: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  LIST_BRANCH: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  STATIC_BRANCH: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  VIRTUAL_SCHEDULED_ENROLLMENT: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  WAIT_UNTIL: CATEGORY_ICON_MAP.QUICK_ACTIONS,
  WHILE_LOOP: CATEGORY_ICON_MAP.QUICK_ACTIONS
});